// extracted by mini-css-extract-plugin
module.exports = {"ad":"dfp-ad-m__ad__zZF_P"};